import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

// Edits what a draft's line items do not carry: its due date and memo. Only a
// DRAFT is editable (`editable` on the billing row); anything in Stripe is
// changed there or voided and posted again.
const UpdateInvoiceMutation = graphql.persisted(
  "UpdateInvoice",
  graphql(`
    mutation UpdateInvoice($input: UpdateInvoiceInput!) {
      updateInvoice(input: $input) {
        invoice {
          id
          status
          dueDate
          memo
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { UpdateInvoiceMutation };

export function useUpdateInvoice() {
  return useMutation(UpdateInvoiceMutation);
}
